import React from 'react'
import styled from "styled-components";
import ButtonLink from "../../atoms/button.link";

function IsRealtorBanner() {
    return (
        <div className="bg-gray100 rounded-16">
            <div className="row align-items-center">
                <div className="col-12 col-lg-6">
                    <ConsultantImage>
                        <img src="/_img/landings/realtor.jpg" className="img-cover" alt="مشاور املاک هستید؟"/>
                    </ConsultantImage>
                </div>

                <div className="col-12 col-lg-6">
                    <Content className="px-lg-56">
                        <h2 className="h1-bold">مشاور املاک هستید؟</h2>
                        <p className="h3-normal mt-8">
                            ۲نبش باعث توسعۀ کسب‌وکار بیش از ۱۵۰۰۰ مشاور املاک متخصص شده. شانس‌تون رو در پیوستن به این مجموعه و توسعۀ کسب‌وکارتون امتحان کنید.
                        </p>

                        <ButtonLink
                            href="/pages/services"
                            hrefAs="/خدمات-2نبش"
                            color="primary"
                            className="mt-16 mt-lg-32"
                        >
                            مشاهده خدمات
                        </ButtonLink>
                    </Content>
                </div>
            </div>
        </div>
    )
}

export default React.memo(IsRealtorBanner);

// styles

const Content = styled.div`
  
  @media(max-width: ${props => props.theme.screenXsMax}) {
      padding: 32px 24px 40px;
  }
`;

const ConsultantImage = styled.div`
    height: 404px;
    
    &, & img {
        border-radius: 0 16px 16px 0;
    }
    
    @media(max-width: ${props => props.theme.screenXsMax}) {
        height: 215px;
        
        &, & img {
            border-radius: 16px 16px 0 0;
        }
    }
`;